import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jianqu",
  "use": "icon-jianqu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jianqu\"><path d=\"M512 69.268c-244.512 0-442.732 198.22-442.732 442.732s198.22 442.732 442.732 442.732 442.732-198.22 442.732-442.732-198.22-442.732-442.732-442.732zM735.075 558.604h-446.15c-25.788 0-46.604-20.816-46.604-46.604s20.816-46.604 46.604-46.604h446.15c25.788 0 46.604 20.816 46.604 46.604s-20.972 46.604-46.604 46.604z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol